import { DictionaryEntry } from "@sdbn/common";

export enum ProcessSelectionActionType {
  PROCESS_STEP = 'PROCESS_STEP', PROCESS_FLOW = 'PROCESS_FLOW'
}

export class ProcessSelectionConfiguration {

  selectOptions = new Array<ProcessSelectOption>();

  constructor(data: any) {
    if (data != null && data.selectOptions != null) {
      for (const entry of data.selectOptions) {
        this.selectOptions.push(new ProcessSelectOption(entry));
      }
    }
  }
}

export class ProcessSelectOption {

  titleDictionaryKey: string;
  titleDictionaryEntry: DictionaryEntry;
  titleIconCss: string;
  descriptionDictionaryKey: string;
  actionType: ProcessSelectionActionType;
  processStepKey: string;
  processFlowKey: string;
  key: any;

  constructor(data: any) {
    this.titleDictionaryKey = data.titleDictionaryKey;
    if (data.titleDictionaryEntry != null) {
      this.titleDictionaryEntry = new DictionaryEntry(data.titleDictionaryEntry);
    }
    this.titleIconCss = data.titleIconCss;
    this.descriptionDictionaryKey = data.descriptionDictionaryKey;
    this.actionType = data.actionType;
    this.processStepKey = data.processStepKey;
    this.processFlowKey = data.processFlowKey;
    this.key = data.key;
  }
}
